import { createContext, useContext, useState } from "react";
import { GLOBAL_CONTROL_HISTORY_ESSBASE_SUMMARY_RECONT_API } from "../config/apiConfig";
import { TREASURY_KRI_ESSBASE_SUMMARY_API } from "../config/apiConfig";
import { securedFetch } from "../utils/api";

const SnowflakeContext = createContext();

export const SnowflakeProvider = ({ children }) => {
  const [selectedPresetDateRange, setSelectedPresetDateRange] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedBusinessEntityID, setSelectedBusinessEntityID] = useState();
  const [localCurrency, setLocalCurrency] = useState(null);

  const [figureDivisors, setFigureDivisors] = useState([
    { name: "Raw", value: 1 },
    { name: "Thousands", value: 1000 },
    { name: "Millions", value: 1000000 },
    { name: "Billions", value: 1000000000 },
  ]);
  const [selectedFigureDivisor, setSelectedFigureDivisor] = useState(
    figureDivisors[0].value,
  );

  const [decimalsIn, setDecimalsIn] = useState([
    { name: "No Decimal", value: "0" },
    { name: "1 Decimal", value: "1" },
    { name: "2 Decimals", value: "2" },
    { name: "3 Decimals", value: "3" },
  ]);
  const [selectedDecimalsIn, setSelectedDecimalsIn] = useState(
    decimalsIn[0].value,
  );

  const [
    globalControlHistoryEssbaseSummaryReconLoading,
    setGlobalControlHistoryEssbaseSummaryReconLoading,
  ] = useState(false);
  const [
    globalControlHistoryEssbaseSummaryReconError,
    setGlobalControlHistoryEssbaseSummaryReconError,
  ] = useState(null);
  const [
    globalControlHistoryEssbaseSummaryReconData,
    setGlobalControlHistoryEssbaseSummaryReconData,
  ] = useState([]);

  const [
    treasuryKRIEssbaseSummaryLoading,
    setTreasuryKRIEssbaseSummaryLoading,
  ] = useState(false);
  const [treasuryKRIEssbaseSummaryError, setTreasuryKRIEssbaseSummaryError] =
    useState(null);
  const [treasuryKRIEssbaseSummaryData, setTreasuryKRIEssbaseSummaryData] =
    useState([]);

  const fetchGlobalControlHistoryEssbaseSummaryReconReport = () => {
    if (selectedBusinessEntityID && selectedStartDate && selectedEndDate) {
      setGlobalControlHistoryEssbaseSummaryReconLoading(true);
      setGlobalControlHistoryEssbaseSummaryReconError(null);
      securedFetch(GLOBAL_CONTROL_HISTORY_ESSBASE_SUMMARY_RECONT_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          businessEntityID: selectedBusinessEntityID,
          startDateRange: selectedStartDate?.format("YYYY-MM-DD"),
          endDateRange: selectedEndDate?.format("YYYY-MM-DD"),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(
              "Failed to fetch Global Control History Essbase Summary Recon Report",
            );
          }
          return res.json();
        })
        .then((data) => {
          setGlobalControlHistoryEssbaseSummaryReconData(data);
        })
        .catch((error) => {
          setGlobalControlHistoryEssbaseSummaryReconError(error.message);
        })
        .finally(() => {
          setGlobalControlHistoryEssbaseSummaryReconLoading(false);
        });
    }
  };

  const fetchTreasuryKRIEssbaseSummaryReport = () => {
    if (selectedBusinessEntityID && selectedStartDate && selectedEndDate) {
      setTreasuryKRIEssbaseSummaryLoading(true);
      setTreasuryKRIEssbaseSummaryError(null);
      securedFetch(TREASURY_KRI_ESSBASE_SUMMARY_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          businessEntityID: selectedBusinessEntityID,
          startDateRange: selectedStartDate?.format("YYYY-MM-DD"),
          endDateRange: selectedEndDate?.format("YYYY-MM-DD"),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(
              "Failed to fetch Treasury KRI Essbase Summary Report",
            );
          }
          return res.json();
        })
        .then((data) => {
          setTreasuryKRIEssbaseSummaryData(data);
        })
        .catch((error) => {
          setTreasuryKRIEssbaseSummaryError(error.message);
        })
        .finally(() => {
          setTreasuryKRIEssbaseSummaryLoading(false);
        });
    }
  };

  return (
    <SnowflakeContext.Provider
      value={{
        selectedBusinessEntityID,
        setSelectedBusinessEntityID,
        selectedPresetDateRange,
        setSelectedPresetDateRange,
        selectedStartDate,
        setSelectedStartDate,
        selectedEndDate,
        setSelectedEndDate,

        figureDivisors,
        setFigureDivisors,
        selectedFigureDivisor,
        setSelectedFigureDivisor,
        decimalsIn,
        setDecimalsIn,
        selectedDecimalsIn,
        setSelectedDecimalsIn,
        localCurrency,
        setLocalCurrency,

        globalControlHistoryEssbaseSummaryReconLoading,
        globalControlHistoryEssbaseSummaryReconError,
        globalControlHistoryEssbaseSummaryReconData,
        fetchGlobalControlHistoryEssbaseSummaryReconReport,

        treasuryKRIEssbaseSummaryLoading,
        treasuryKRIEssbaseSummaryError,
        treasuryKRIEssbaseSummaryData,
        fetchTreasuryKRIEssbaseSummaryReport,
      }}
    >
      {children}
    </SnowflakeContext.Provider>
  );
};

export const useSnowflakeContext = () => useContext(SnowflakeContext);
